const scrolls = document.querySelectorAll('.js-scroll')
if (scrolls.length) {
  const speed = 0.5
  const params = []

  const update = () => {
    scrolls.forEach((scroll, index) => {
      let pos = params[index] ?? 0
      pos += speed
      if (scroll.clientWidth / 2 < pos) {
        pos -= scroll.clientWidth / 2
      }

      scroll.style.transform = `translate3d(${-pos}px, 0, 0)`

      params[index] = pos
    })

    requestAnimationFrame(update)
  }
  update()
}
